import React from 'react'
import css from './style.scss'

const Plan=(props)=>(
  <div className={css.plan}>
    <div className={css.plan_title}>{props.title}</div>
    {props.children}
  </div>
)

const Features=(props)=>(
  <div className={css.plan_features}>
    {props.children}
  </div>
)

const Feature=(props)=>(
  <div className={css.plan_feature}>
    {props.children}
  </div>
)
const Price=(props)=>(
  <div className={css.price}>
    <div className={css.price_amount}>{props.price}</div>
    <div className={css.price_when}>{props.when}</div>
  </div>
)


export default (props)=>(
  <div className={css.pricingPage}>
    <div className={css.plansTitle}>We offer different plans</div>
    <div className={css.plansSubtitle}>Because every Instagram profile is different.</div>
    <div className={css.plans}>
      <Plan title="Starter">
        <Features>
          <Feature>Backups only last 7 day</Feature>
          <Feature>Analysis included</Feature>
          <Feature>1 Instagram account</Feature>
          <Feature>No Team members</Feature>
          <Feature>Ads-supported</Feature>
        </Features>
        <Price price="FREE" when="forever"/>
      </Plan>
      <Plan title="Awesome">
        <Features>
          <Feature>Backups all your Instagram Stories</Feature>
          <Feature>Analysis included</Feature>
          <Feature><b>3</b> Instagram accounts</Feature>
          <Feature>Up to <b>2</b> Team members</Feature>
          <Feature>Export all your Stories</Feature>
          <Feature>No ads</Feature>
        </Features>
        <Price price="9.99€" when="every month"/>

      </Plan>
      <Plan title="Business">
        <Features>
          <Feature>Backups all your Instagram Stories</Feature>
          <Feature>Analysis included</Feature>
          <Feature><b>6</b> Instagram accounts</Feature>
          <Feature>Up to <b>10</b> Team members</Feature>
          <Feature>Export all your Stories</Feature>
          <Feature>No ads</Feature>
        </Features>
        <Price price="29.99€" when="every month"/>
      </Plan>
    </div>

  </div>
)



// WEBPACK FOOTER //
// ./src/components/home_page/landing/sections/pricing.js